module.exports = __webpack_public_path__ + "static/media/aucun-aliment.eb6b8a2a.svg";